import { createSelector, createFeatureSelector } from '@ngrx/store';
import { UsersState } from './users.reducer';

export const selectUsersState = createFeatureSelector<UsersState>('users');

// List selectors
export const selectUsers = createSelector(
  selectUsersState,
  state => state.users
);

export const selectUserItems = createSelector(
  selectUsers,
  users => users?.items ?? []
);

export const selectUsersLoading = createSelector(
  selectUsersState,
  state => state.loading
);

export const selectUsersError = createSelector(
  selectUsersState,
  state => state.error
);

export const selectCurrentFilter = createSelector(
  selectUsersState,
  state => state.currentFilter
);

export const selectTotalCount = createSelector(
  selectUsers,
  users => users?.totalCount ?? 0
);

export const selectTotalPages = createSelector(
  selectUsers,
  users => users?.totalPages ?? 0
);

export const selectCurrentPage = createSelector(
  selectUsers,
  users => users?.pageNumber ?? 1
);

export const selectPageSize = createSelector(
  selectUsers,
  users => users?.pageSize ?? 25
);

export const selectSortBy = createSelector(
  selectUsersState,
  state => state.sortBy
);

export const selectSortOrder = createSelector(
  selectUsersState,
  state => state.sortOrder
);

// Roles selectors
export const selectRoles = createSelector(
  selectUsersState,
  state => state.roles
);

export const selectRolesLoading = createSelector(
  selectUsersState,
  state => state.rolesLoading
);
